import { z } from 'zod'

export const passwordSchema = z
  .string()
  .min(10, 'Password must be at least 10 characters')
  .regex(/^(?=.*[a-z])/, 'Password must contain at least 1 lowercase letter')
  .regex(/^(?=.*[A-Z])/, 'Password must contain at least 1 uppercase letter')
  .regex(/^(?=.*\d)/, 'Password must contain at least 1 number')
  // .regex(/^(?=.*[^$*.\[\]{}()?!"@#%&/\\,><':;|_~`+=-])/, 'Password must contain at least 1 special character')
  .regex(/^(?=.*[#?!@$%^&*-])/, 'Password must contain at least 1 special character')
  .regex(
    /^[A-Za-z\d^$*.[\]{}()?!"@#%&/\\,><':;|_~`+=-]+$/,
    'Password can only contain letters, numbers, and these special characters: ^ $ * . [ ] { } ( ) ? - " ! @ # % & / \\ , > < \' : ; | _ ~ ` + = (no spaces)',
  )
  .refine((val) => !val.includes(' '), 'Password cannot contain spaces')

export const loginSchema = z.object({
  email: z.string().email('Invalid email address'),
  password: passwordSchema,
})

export const signupSchema = loginSchema
  .extend({
    confirmPassword: passwordSchema,
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords don't match",
    path: ['confirmPassword'],
  })

export const requestPasswordSchema = z.object({
  email: z.string().email('Please enter a valid email address'),
})

export const resetPasswordSchema = z.object({
  code: z.string(),
  newPassword: passwordSchema,
  confirmPassword: passwordSchema,
})

export const updatePasswordSchema = z
  .object({
    oldPassword: z.string().min(1, 'Current password is required'),
    newPassword: passwordSchema,
    confirmPassword: z.string(),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: "Passwords don't match",
    path: ['confirmPassword'],
  })

export type LoginFormData = z.infer<typeof loginSchema>
export type SignupFormData = z.infer<typeof signupSchema>
export type RequestPasswordFormData = z.infer<typeof requestPasswordSchema>
export type ResetPasswordFormData = z.infer<typeof resetPasswordSchema>
export type UpdatePasswordFormData = z.infer<typeof updatePasswordSchema>
